var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-form',{ref:"formTransferSwap",staticClass:"fill-height",attrs:{"lazy-loading":""}},[_c(_vm.componentToShow,{ref:"formTransferSwapChild",tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }